{
    "name": "Rocoto Pepper",
    "binomial_name": "",
    "common_names": [],
    "description": "",
    "sun_requirements": "",
    "sowing_method": "",
    "spread": 0,
    "row_spacing": 0,
    "height": 0,
    "growing_degree_days": 0,
    "companions": [],
    "image": "",
    "icon": "/crops/icons/rocoto-pepper.avif"
}